import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13c1f9c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../dashboard.style.scss?vue&type=style&index=0&id=13c1f9c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1f9c6",
  null
  
)

export default component.exports